import { Controller } from "@hotwired/stimulus";
import { errorMessages, flashAlert, notifyError } from "../../../components/flash_alert";
import { swal } from "../../../components/init_sweet_alert";
import { closeModal, isSwalConfirmed, isValidEmail, toggleClass } from "../../../utils/misc";
import { hasDroppedFiles } from "../../../components/dropzone";
import { displaySpinner, hideSpinner } from "../../../sales_invoices/send_invoice_by_email";

const MAX_NUMBER_OF_RECIPIENT_EMAILS_ALLOWED = 6;

export default class extends Controller {
  static targets = [
    "spinner",
    "modalContainer",
    "emailModal",
    "form",
    "emailErrorMessage",
    "addRecipientEmailButton",
    "recipientEmailInputTemplate",
    "recipientEmailInput",
    "recipientEmailsList",
  ];

  connect() {
    window.$(this.element).on("shown.bs.modal", (event) => {
      const url = event.relatedTarget.dataset.url;
      this._fillModal(url);
    });
  }

  addRecipientEmail() {
    this.recipientEmailsListTarget.insertAdjacentHTML("beforeend", this.recipientEmailInputTemplateTarget.innerHTML);
    this._toggleAddRecipientEmailButton();
  }

  removeRecipientEmail(e) {
    e.currentTarget.closest(".recipient-email-input").remove();
    this._toggleAddRecipientEmailButton();
    this._toggleInvalidRecipientEmailsErrorMessage();
  }

  onEmailBlur() {
    this._toggleInvalidRecipientEmailsErrorMessage();
  }

  validateSubmission(e) {
    e.preventDefault();

    this._toggleInvalidRecipientEmailsErrorMessage();

    if (this._allRecipientEmailsValid()) {
      swal({
        title: "Êtes-vous sûr de vouloir envoyer cet e-mail ?",
        buttons: { non: true, oui: true },
        className: "custom-swal-modal",
      }).then((value) => {
        if (isSwalConfirmed(value)) {
          this._handleSubmission();
        }
      });
    } else {
      this.recipientEmailInputTargets[0].focus();
    }
  }

  _handleSubmission() {
    const dropzone = this.formTarget.dropzone;

    if (hasDroppedFiles(dropzone)) {
      dropzone.processQueue();
    } else {
      Rails.fire(this.formTarget, "submit");
    }
    displaySpinner();
  }

  handleSuccess(e) {
    flashAlert(e.detail[0].message);
    closeModal(this.element.id);
    hideSpinner();
  }

  handleError(e) {
    notifyError(e.detail[0].error_message);
    hideSpinner();
  }

  _allRecipientEmailsValid() {
    return this.recipientEmailInputTargets.every((emailInput) => isValidEmail(emailInput.value));
  }

  _toggleInvalidRecipientEmailsErrorMessage() {
    toggleClass(this.emailErrorMessageTarget, "hidden", !this._allRecipientEmailsValid());
  }

  _toggleAddRecipientEmailButton() {
    toggleClass(
      this.addRecipientEmailButtonTarget,
      "hidden",
      this.recipientEmailInputTargets.length < MAX_NUMBER_OF_RECIPIENT_EMAILS_ALLOWED
    );
  }

  _fillModal(url) {
    const controller = this;

    fetch(url, {
      method: "get",
      headers: { accept: "text/html_fragment" },
    })
      .then((response) => {
        if (response.ok) {
          return response.text();
        } else {
          notifyError(errorMessages(response.status));
          closeModal(controller.element.id);
        }
      })
      .then((data) => {
        this.modalContainerTarget.innerHTML = data || "";
      });
  }
}
